<template>
  <v-app>
    <v-main>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              <span class="headline">Suggested Post</span>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="submitToPagesOption"
                row
                class="d-flex justify-center"
              >
                <v-radio
                  v-for="option in submitToPagesOptions"
                  v-bind:key="option.value"
                  :label="option.text"
                  :value="option.value"
                />
              </v-radio-group>
              <v-autocomplete
                v-model="pagesToSubmit"
                :items="pages"
                item-text="name"
                item-value="id"
                chips
                deletable-chips
                label="Choose pages to submit"
                multiple
                :disabled="!pages.length"
                v-if="submitToPagesOption === 'pages'"
              />
              <v-autocomplete
                v-model="groupToSubmit"
                :items="groups"
                item-text="name"
                item-value="id"
                label="Choose group to submit"
                :disabled="!groups.length"
                v-if="submitToPagesOption === 'group'"
              />
              <v-textarea
                v-model="submissionText"
                label="Submission text"
                auto-grow
              />
              <v-data-table
                :headers="headers"
                :items="replacements"
                item-key="token"
                hide-default-footer
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="submissionText += item.token"
                  >
                    mdi-plus-circle
                  </v-icon>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="submit"
                :disabled="!canSubmit"
                v-text="'Submit'"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <batch-progress v-for="batchID in batchIDs" :key="batchID" :batchID="batchID"/>
    </v-main>
  </v-app>
</template>
<script>
import batchProgress from './batchProgress.vue'

export default {
  components: {
    batchProgress
  },

  data() {
    return {
      submissionText: '',
      submitToPagesOption: 'all',
      pagesToSubmit: [],
      groupToSubmit: null,
      pages: [],
      groups: [],
      batchIDs: [],
      headers: [
        { text: 'Token', value: 'token', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Add to text', value: 'actions', sortable: false },
      ],
      submitToPagesOptions: [
        { text: 'All', value: 'all' },
        { text: 'Pages', value: 'pages' },
        { text: 'Group', value: 'group' },
      ],
      replacements: [
        {
          token: '{page_name}',
          description: 'The name of the page'
        },
        {
          token: '{sub_link}',
          description: 'The page\'s submission link'
        },
        {
          token: '{hof_link}',
          description: 'The page\'s Hall of Fame link'
        },
        {
          token: '{my_submissions}',
          description: 'The page\'s My Submissions link'
        },
        {
          token: '{subs_this_year}',
          description: 'The number of submissions to the page in the last 12 months'
        },
        {
          token: '{posts_this_year}',
          description: 'The number of posts made by the page in the last 12 months'
        },
        {
          token: '{top_post_link}',
          description: 'A link to the page\'s top post of all time'
        },
      ],
    };
  },

  computed: {
    canSubmit() {
      switch (this.submitToPagesOption) {
        case 'pages':
          if (this.pagesToSubmit.length === 0) {
            return false;
          }
        case 'group':
          if (this.groupToSubmit === null) {
            return false;
          }
      }
      return this.submissionText.length > 0;
    },
  },

  created() {
    this.fetchPages();
    this.fetchGroups();
  },

  methods: {
    fetchPages() {
      axios
        .get("/api/developer/pagenames")
        .then(response => {
          this.pages = response.data;
        });
    },

    fetchGroups() {
      axios
        .get("/api/developer/groupnames")
        .then(response => {
          this.groups = response.data;
        });
    },

    submit() {
      axios
        .post("/api/developer/suggestedpost", {
          submissionText: this.submissionText,
          submitToPagesOption: this.submitToPagesOption,
          pagesToSubmit: this.pagesToSubmit,
          groupToSubmit: this.groupToSubmit,
        })
        .then(response => {
          this.batchIDs.push(response.data.batch.id);
          this.submissionText = '';
          this.pagesToSubmit = [];
          this.groupToSubmit = [];
        });
    },
  },
};
</script>

<style>

/* something is adding margin-bottom: 0.5rem to the radio button labels?? */
.v-label {
  margin-bottom: 0 !important;
}
</style>